<template>
  <div id="contents">
    <div id="ticketList" class="container">
      <h3 class="stitle mb50">예약내역{{ pgText }}</h3>
      <div class="schbox mb50">
        <ul>
          <li>
            <label for="findType">상품구분</label>
            <select id="findType" name="findType" title="검색 목록" v-model="searchCondtion.rvItemDiv">
              <option v-for="pdDiv in rvItemDivList" :key="pdDiv.cd" :value="pdDiv.cd">{{ pdDiv.cdNm }}</option>
            </select>
          </li>
          <li>
            <label for="">예약상태</label>
            <div class="radio_wrap">
              <span class="radiobox" v-for="progSitu in progSituList" :key="progSitu.cd">
                <input type="radio" name="rvProgSitu" :id="'radiock' + progSitu.cd" :value="progSitu.cd" v-model="searchCondtion.rvProgSitu" />
                <label :for="'radiock' + progSitu.cd">{{ progSitu.cdNm }}</label>
              </span>
            </div>
          </li>
          <li class="wdfull">
            <label for="">체험일</label>
            <div class="calwrap">
              <p class="calsel_period">
                <span class="calselbox">
                  <date-pick v-bind="dateOpt" :startWeekOnSunday="true" v-model="searchCondtion.reserveStartDt">
                    <template v-slot:default="{ open, toggle, inputValue, processUserInput }">
                      <input type="text" :value="inputValue" @input="processUserInput($event.target.value)" @focus="open()" @click="open()" />
                      <button class="calsel" type="button" @click="toggle">체험 시작일 선택</button>
                    </template>
                  </date-pick>
                </span>
                <span>~</span>
                <span class="calselbox">
                  <date-pick v-bind="dateOpt" :startWeekOnSunday="true" v-model="searchCondtion.reserveEndDt">
                    <template v-slot:default="{ open, toggle, inputValue, processUserInput }">
                      <input type="text" :value="inputValue" @input="processUserInput($event.target.value)" @focus="open()" @click="open()" />
                      <button class="calsel" type="button" @click="toggle">체험 종료일 선택</button>
                    </template>
                  </date-pick>
                </span>
              </p>
              <p class="period_list">
                <a href="#" @click="() => setReserveEndDt(1, 'W')">1주일</a>
                <a href="#" @click="() => setReserveEndDt(1, 'M')">1개월</a>
                <a href="#" @click="() => setReserveEndDt(3, 'M')">3개월</a>
                <a href="#" @click="() => setReserveEndDt(6, 'M')">6개월</a>
              </p>
            </div>
          </li>
        </ul>
        <input class="btn_search" type="submit" value="조회" @click="getSearchList" style="cursor: pointer" />
      </div>
      <div v-for="reserv in reservList" :key="reserv.bundleRvNo" style="position: relative" class="mb20">
        <p class="ticket_tit">
          <router-link :to="'/' + (currentRouteType || 'ind') + '/reservations/' + reserv.bundleRvNo">
            <!-- <a class="" href="javascript:void(0)" @click="() => goDetail(reserv.bundleRvNo)"> -->
            예약번호
            <strong class="clickable">{{ reserv.bundleRvNo }}</strong>
          </router-link>
        </p>
        <div class="tb_wrap res_tbl_wrap">
          <table class="tb_basic reserve_table">
            <caption>예약번호 {{ reserv.bundleRvNo }}</caption>
            <thead>
              <tr class="tbg">
                <th scope="col">예약일</th>
                <th scope="col">체험일</th>
                <th scope="col">예약상태</th>
                <th scope="col">상품</th>
                <th scope="col">회차</th>
                <th scope="col">인원</th>
                <th scope="col" class="btn_col">변경/취소</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(rv, i) in reserv.rvList" :key="rv.pdRvNo">
                <td v-if="i === 0" :rowspan="reserv.rvList.length" data-label="예약일">{{ rv.rvDtm }}&nbsp;({{ rv.rvDtmDy }})</td>
                <td v-if="i === 0" :rowspan="reserv.rvList.length" data-label="체험일">{{ rv.expVisitRvdt }}&nbsp;({{ rv.expVisitRvdtDy }})</td>
                <td v-if="rv.rvProgSitu === '09' || rv.rvProgSitu === '10'" daabel="예약상태">
                  {{ rv.indiRvProgSituNm }}&nbsp;({{ rv.receiveYnNm }})
                </td>
                <td v-else data-label="예약상태">{{ rv.indiRvProgSituNm }}</td>
                <td data-label="상품">{{ rv.mrktnPdNm }}</td>
                <td data-label="회차">
                  {{ rv.mrktnScheSeqNm }}
                  ({{ rv.startTm }}~{{ rv.endTm }})
                </td>
                <td data-label="인원">
                  <ul class="tlist1">
                    <li>
                      <strong>체험자</strong>
                      <span>{{ rv.experPcnt }}인</span>
                    </li>
                    <li v-if="rv.leaderPcnt > 0">
                      <strong>보호자</strong>
                      <span>{{ rv.leaderPcnt }}인</span>
                    </li>
                  </ul>
                </td>
                <td v-if="i === 0" :rowspan="reserv.rvList.length" data-label="변경/취소">
                  <div class="ticket_btnbox">
                    <a v-if="reserv.changePossYn === 'Y'" class="" href="javascript:void(0)" @click="() => goModify(reserv.bundleRvNo, reserv.expVisitRvdt)">
                      변경
                    </a>
                    <!-- <a v-if="rv.cancelPossYn === 'Y'" class="btn_color2" href="javascript:void(0)" @click="() => goCancel(reserv.bundleRvNo)">취소</a> -->
                    <a v-if="reserv.cancelPossYn === 'Y'" class="btn_color2" href="javascript:void(0)" @click="() => goCancelN(reserv.bundleRvNo)">취소</a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
        <div slot="no-more">더 이상 예약 내역이 없습니다.</div>
        <div slot="no-results">예약 내역이 없습니다.</div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { getCodeList } from '@/api/api_comm';
import { getReservations } from '@/api/api_reserve';
import { DATE_LOCALIZATION } from '@/utils/const.js';
import { toJspPage } from '@/utils/reserve';
import DatePick from 'vue-date-pick';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  components: { DatePick, InfiniteLoading },
  data() {
    return {
      dateOpt: { ...DATE_LOCALIZATION, selectableYearRange: { from: 2012, to: new Date().getFullYear() + 2 } },
      page: 1,
      infiniteId: +new Date(),
      reservList: [],
      searchCondtion: {
        rvItemDiv: '', //상품구분
        rvProgSitu: '', //예약상태
        reserveStartDt: moment(new Date()).format('YYYY-MM-DD'), //체험일 시작
        reserveEndDt: moment(new Date()).add(1, 'Y').format('YYYY-MM-DD'), //체험일 종료
      },
      param: null,
      rvItemDivList: [
        { cd: '', cdNm: '전체', pdDiv: '' },
        { cd: '01', cdNm: '청소년체험관', pdDiv: '02' },
        { cd: '02', cdNm: '어린이체험관', pdDiv: '01' },
        { cd: '10', cdNm: '숙련기술체험관', pdDiv: '10' },
        { cd: '13', cdNm: '진로설계관', pdDiv: '03' },
        { cd: '09', cdNm: '메카이브', pdDiv: '09' },
        { cd: '08', cdNm: '이벤트/행사', pdDiv: '08' },
        //{ cd: '20', cdNm: 'Onjob', pdDiv: '20' },
        { cd: '20', cdNm: '미래직업관', pdDiv: '20' },
      ],
      progSituList: [
        { cd: '', cdNm: '전체' },
        { cd: '01', cdNm: '가예약', arrayTurn: 1, sortCd: '066' },
        { cd: '03', cdNm: '예약완료', arrayTurn: 3, sortCd: '066' },
        { cd: '05', cdNm: '예약취소', arrayTurn: 5, sortCd: '066' },
      ],
    };
  },
  computed: {
    pdDiv() {
      const rvItem = this.rvItemDivList.find((e) => e.cd === this.searchCondtion.rvItemDiv);
      return rvItem ? rvItem.pdDiv : '';
    },
    pgText() {
      return this.groupPersDiv === '01' ? '(단체)' : '(개인)';
    },
  },
  watch: {
    groupPersDiv() {
      this.getSearchList();
    },
  },
  methods: {
    async getList() {
      const result = await getReservations({ ...this.param, currentPageNo: this.page });
      const data = result.data || {};
      const { success, response, apiError } = data;
      if (success) {
        const bundleList = {};
        response.reservList.forEach((e) => {
          if (bundleList[e.bundleRvNo]) {
            bundleList[e.bundleRvNo].push(e);
          } else {
            bundleList[e.bundleRvNo] = [e];
          }
        });

        const reserveList = Object.entries(bundleList).map(([bundleRvNo, rvList]) => {
          let totalPrice = 0;
          let changePossYn = 'N';
          let cancelPossYn = 'N';
          rvList.forEach((e) => {
            totalPrice += e.rvAmt;
            if (e.changePossYn === 'Y') changePossYn = 'Y';
            if (e.cancelPossYn === 'Y') cancelPossYn = 'Y';
          });
          return { bundleRvNo, totalPrice, rvList, changePossYn, cancelPossYn };
        });
        return reserveList;
      }
    },
    async getSearchList() {
      sessionStorage.setItem('reCondition', JSON.stringify(this.searchCondtion));

      this.setParam();
      this.page = 1;
      this.reservList = [];
      this.infiniteId += 1;
    },
    infiniteHandler($state) {
      this.getList().then((data) => {
        if (data.length) {
          this.page += 1;
          this.reservList.push(...data);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    async getCode() {
      const codeList = await getCodeList(['010', '066']);
      this.rvItemDivList = codeList['010'];
      this.progSituList = codeList['066'];
    },
    setReserveEndDt(num = 1, type = 'd') {
      this.searchCondtion.reserveEndDt = moment(new Date()).add(num, type).format('YYYY-MM-DD');
    },
    setParam() {
      const param = {
        ...this.searchCondtion,
        groupPersDiv: this.groupPersDiv,
        pdDiv: this.pdDiv,
        reserveStartDt: (this.searchCondtion.reserveStartDt || '').replace(/-/g, ''),
        reserveEndDt: (this.searchCondtion.reserveEndDt || '').replace(/-/g, ''),
      };
      this.param = param;
    },
    onDateChange() {},
    goDetail(bundleRvNo) {
      toJspPage('/resvr/reserveDetail.do', { bundleRvNo });
    },
    goModify(bundleRvNo, expVisitRvdt) {
      alert(
        '1. 체험일 및 체험상품은 변경 불가(예약 취소 후 다시 예약 진행)\r\n2. 체험 인원 및 회차 변경 시 체험실 재선택이 필요 할 수 있습니다.(기존 체험실 자동 삭제)\r\n3. 예약변경적용(저장) 버튼을 클릭하셔야 변경내용 적용이 완료됩니다.\r\n※문의 사항은 고객센터(☏ 1644-1333)를 이용해주세요.',
      );
      this.$router.push(`/${this.currentRouteType}/reservations/${bundleRvNo}/change`);
      //toJspPage('/resvr/reserveModify.do', { bundleRvNo, expVisitRvdt });
    },
    goCancel(bundleRvNo) {
      toJspPage('/resvr/reserveCancel.do', { bundleRvNo });
    },
    goCancelN(bundleRvNo) {
      this.$router.push(`/${this.currentRouteType}/reservations/${bundleRvNo}/cancel`);
    },
  },
  created() {
    //this.getCode(); // 그냥 하드코딩으로
    const reConditon = sessionStorage.getItem('reCondition');
    try {
      if (reConditon) {
        const con = JSON.parse(reConditon);
        this.searchCondtion.rvItemDiv = con.rvItemDiv;
        this.searchCondtion.rvProgSitu = con.rvProgSitu;
        this.searchCondtion.reserveStartDt = con.reserveStartDt;
        this.searchCondtion.reserveEndDt = con.reserveEndDt;
      }
    } catch (e) {}
    this.setParam();
  },
  mounted() {
    //this.getList();
  },
};
</script>

<style lang="scss" scoped>
::v-deep .vdpOuterWrap {
  line-height: initial;
}
.reserve_table {
  word-break: keep-all;
  .btn_col {
    width: 120px;
  }
}
</style>
